export default __webpack_public_path__ + "static/BrandonGrotesque-BlackItalic-c99a8e086f72ae25e2d21f239c4afb75.woff2";